"use strict";
/**
 * Copyright (c) Haiku 2016-2018. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
function isIE(window) {
    if (!window) {
        return false;
    }
    if (!window.navigator) {
        return false;
    }
    if (!window.navigator.userAgent) {
        return false;
    }
    return (window.navigator.userAgent.indexOf('MSIE') !== -1 ||
        navigator.appVersion.indexOf('Trident') > 0);
}
exports.default = isIE;
//# sourceMappingURL=isIE.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@haiku/core/lib/renderers/dom/isIE.js
// module id = 137
// module chunks = 35783957827783 127651196306611 162898551421021